import { defineMessages } from 'react-intl';

export default defineMessages({
  error: { defaultMessage: 'Transaction amount is incorrect' },
});
